import { galleryImages } from "@/mocks/galleryData";

const uiGalleryImages = galleryImages.slice(0, 6);

export default function UIGallery() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#EAF5E1] text-[#7FBF3F] text-xs font-semibold px-4 py-2 rounded-full mb-4">
            <i className="ri-image-line"></i>Project Gallery
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#212121] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            See Projects in Action
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base">
            Real photographs from our villa plots, gated community layouts, and residential developments across Sarjapur Road, Bengaluru.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {uiGalleryImages.map((img, idx) => (
            <div
              key={img.id}
              className={`relative group overflow-hidden rounded-2xl border border-gray-100 ${idx === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
            >
              <div className={`w-full overflow-hidden ${idx === 0 ? "h-64 md:h-full min-h-[300px]" : "h-48"}`}>
                <img
                  src={img.src}
                  alt={`${img.title} - eco-friendly villa plots Bangalore`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4A]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <div>
                  <span className="bg-[#7FBF3F]/80 text-white text-xs px-2 py-1 rounded-full mb-2 inline-block">{img.category}</span>
                  <p className="text-white font-semibold text-sm">{img.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/gallery"
            className="inline-flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-image-2-line"></i>View Full Gallery
          </a>
        </div>
      </div>
    </section>
  );
}
